<template>
    <div class="wrap">
        <div class="title">{{ title }}</div>
        <div class="titleTime">{{ time }}</div>
        <div class="line"></div>
        <div class="paragraph">估值线买点是<common-data name="appShortName_37"/>以其原创多因子估值数据构造的另类因子，可以构建基于估值线买点的量化选股策略。</div>
        <div class="first">一、策略构建原理</div>
        <div class="paragraph">
            在系统股票池中，运用估值线买点因子精选股价达到估值线买点的股票，同时结合净现比、净利润同比等筛选业绩稳健增长、质地好、被机构看好且上涨前股价波动稳定的优质股票，获取收益。
        </div>
        <div class="first">二、选择因子组合</div>
        <div class="paragraph">1、估值线买点（另类因子）：描述股票当前股价处于估值线买点；</div>
        <div class="paragraph">2、净现比_TTM（财务类-财务质量）：描述获得的净利润多以现金形式流入企业；</div>
        <div class="paragraph">3、净利润_TTM同比（财务类-成长性）：描述公司近期业绩增幅较大；</div>
        <div class="paragraph">4、股东数目偏离度（公司资料类-持股结构）：描述股票持股集中度变高,被机构看好；</div>
        <div class="paragraph">5、低振幅（量价类-波动率因子）：描述股票上涨前股价波动平稳。</div>
        <div class="img_center">
            <img class="img" src="./img/图片1.png" />
        </div>
        <div class="paragraph">未引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <img class="img" src="./img/图片2.png" />
        </div>
        <div class="paragraph">引入多因子估值数据做风险控制策略回测结果：</div>
        <div class="img_center">
            <img class="img" src="./img/图片3.png" />
        </div>
        <div class="first">三、结论</div>
        <div class="paragraph">
            综上可见，<common-data name="appShortName_37"/>的估值线买点因子，为用户及时提供了更精准的估值线买点信息，辅之以基本面因子可以找到基本面优秀且即将上涨的股票，引入多因子估值数据做风险控制，可显著提升策略的表现，从而帮助用户提前占据领先地位、获取更高收益。
        </div>

        <div style="height: 20px"></div>
        <div class="symbolarea">
            <div class="symbol"></div>
            <span class="symboltext">免责说明</span>
        </div>
        <div class="bottom">
            <div class="bottomText">本案例仅用于说明<common-data name="appShortName_37"/>量化功能的使用方法，不构成任何投资建议。</div>
        </div>
        <div style="height: 60px"></div>
    </div>
</template>
<script>
export default {
    props: ["title", "time"], // 接收父组件传递的时间参数
};
</script>
<style scoped src="../common.css"></style>
